import React, { useEffect, useState } from 'react'
import TweetEmbed from './TweetEmbed';
import axios from 'axios';
import Spinner from '../../Spinner';
import { useUserContext } from '../../../contexts/UserContext';
import { Fire } from '@phosphor-icons/react';

export default function Tweets(props) {
    const {
        getToken
    } = useUserContext();

    const {
        fire
    } = props;

    const [tweets, setTweets] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const getTweets = () => {
        setError(false);
        setLoading(true);

        if (fire.areaAC > 200) {
            getToken().then((token) => {
                axios.get(`https://firewatch-api.space-eyes.com/fires/tweets?fire_name=${fire.name}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
                .then((response) => {
                    setTweets(response.data);
                    setLoading(false);
                }).catch((err) => {
                    console.log('error getting tweets', err);
                    setLoading(false);
                    setError('Trouble fetching tweets. Please try again.')
                });
            })
        } else {
            setTweets([]);
            setLoading(false);
        }
    }

    useEffect(() => {
        getTweets()
    }, []);

    return (
        <div className='fire-popup-tweets'>
            <div style={{ fontSize: '2rem' , color: 'black' }}>Twitter/X </div>
            <div style={{ fontSize: '0.8rem' , color: 'black', marginBottom: '0.5rem' }}>Real-time posts related to the fire from social media, using the fire's name to gather relevant updates, photos, and eyewitness reports. This feature activates for fires over 200 acres, providing an additional layer of on-the-ground insight that can supplement official data with public observations and evolving local narratives.</div>
            {loading ?
            <Spinner />
            :
            tweets && tweets.length === 0 ?
            <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center', 
                padding: '2rem',
                textAlign: 'center',
                color: '#666'
            }}>
                <div style={{ fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                    No tweets available for this fire
                </div>
                <div style={{ fontSize: '0.9rem' }}>
                    Check back later for social media updates or try a different fire
                </div>
            </div>
            :
            <div  className='fire-popup-tweets-container'>
                {tweets && tweets.map((tweet, idx) => {
                    return (
                        <div key={tweet.tweet_id} style={{ marginBottom: idx === tweets.length - 1 ? '1rem' : '0' }}>
                            <TweetEmbed tweetId={tweet.tweet_id} />
                        </div>
                    )
                })}
            </div>
            }
            {error && (
                <div className='fire-popup-tweets-error-state'>
                    <div className='fire-popup-tweets-error-state-icon'>
                        <Fire size={48} color="#ccc" weight="light" />
                    </div>
                    <div className='fire-popup-tweets-error-state-title'>
                        Unable to load tweets
                    </div>
                    <div className='fire-popup-tweets-error-state-description'>
                        {error}
                    </div>
                </div>
            )}
        </div>
    )
}
